import { defineContainer } from './vue-component-lib/utils';
export const AtomAlert = defineContainer('atom-alert', undefined, [
    'color',
    'icon',
    'messageTitle',
    'messageText',
    'actionText',
    'close',
    'atomClose',
    'atomAction'
]);
export const AtomBadge = defineContainer('atom-badge', undefined, [
    'type'
]);
export const AtomBreadcrumb = defineContainer('atom-breadcrumb', undefined, [
    'items'
]);
export const AtomButton = defineContainer('atom-button', undefined, [
    'color',
    'disabled',
    'download',
    'expand',
    'fill',
    'shape',
    'href',
    'loading',
    'mode',
    'rel',
    'size',
    'target',
    'type',
    'click'
]);
export const AtomCarousel = defineContainer('atom-carousel', undefined, [
    'loop',
    'autoplay',
    'thumbnails',
    'hasNavigation',
    'hasPagination'
]);
export const AtomCarouselItem = defineContainer('atom-carousel-item', undefined);
export const AtomChip = defineContainer('atom-chip', undefined, [
    'disabled',
    'activated',
    'outline',
    'mode',
    'icon',
    'close',
    'atomClick'
]);
export const AtomCol = defineContainer('atom-col', undefined, [
    'size',
    'sizeSm',
    'sizeMd',
    'sizeLg',
    'offset',
    'offsetSm',
    'offsetMd',
    'offsetLg',
    'push',
    'pull'
]);
export const AtomContainer = defineContainer('atom-container', undefined, [
    'hasPadding'
]);
export const AtomGrid = defineContainer('atom-grid', undefined, [
    'fixed'
]);
export const AtomIcon = defineContainer('atom-icon', undefined, [
    'color',
    'icon',
    'size'
]);
export const AtomInput = defineContainer('atom-input', undefined, [
    'autocomplete',
    'autofocus',
    'clearInput',
    'clearOnEdit',
    'color',
    'counter',
    'counterFormatter',
    'debounce',
    'disabled',
    'enterKeyHint',
    'errorText',
    'fill',
    'hasError',
    'helperText',
    'icon',
    'inputmode',
    'label',
    'labelPlacement',
    'max',
    'maxlength',
    'min',
    'minlength',
    'mode',
    'multiple',
    'name',
    'passwordToggle',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'shape',
    'step',
    'type',
    'value',
    'atomFocus',
    'atomBlur',
    'atomChange',
    'atomInput'
]);
export const AtomListSlider = defineContainer('atom-list-slider', undefined, [
    'hasNavigation',
    'centralized',
    'clickNext',
    'clickPrev'
]);
export const AtomListSliderItem = defineContainer('atom-list-slider-item', undefined);
export const AtomSelect = defineContainer('atom-select', undefined, [
    'color',
    'disabled',
    'errorText',
    'fill',
    'helperText',
    'icon',
    'label',
    'mode',
    'multiple',
    'name',
    'placeholder',
    'readonly',
    'value',
    'options',
    'atomBlur',
    'atomCancel',
    'atomChange',
    'atomDismiss',
    'atomFocus'
]);
export const AtomTag = defineContainer('atom-tag', undefined, [
    'color',
    'icon',
    'customBackgroundColor',
    'customTextColor'
]);
export const AtomTextarea = defineContainer('atom-textarea', undefined, [
    'autocomplete',
    'autofocus',
    'autoGrow',
    'clearOnEdit',
    'color',
    'cols',
    'counter',
    'counterFormatter',
    'debounce',
    'disabled',
    'enterKeyHint',
    'errorText',
    'fill',
    'hasError',
    'helperText',
    'icon',
    'inputmode',
    'label',
    'labelPlacement',
    'maxlength',
    'minlength',
    'mode',
    'name',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'rows',
    'shape',
    'step',
    'value',
    'wrap',
    'atomFocus',
    'atomBlur',
    'atomChange',
    'atomInput'
]);
//# sourceMappingURL=index.js.map